/**
 * Cooldown for "Resend confirmation email". Matches Supabase Auth's default
 * per-user email rate limit, so the button never offers a resend the server
 * would reject. The send time is kept per address in sessionStorage so a
 * reload doesn't reset the timer.
 */
export const RESEND_COOLDOWN_MS = 60_000;

const KEY_PREFIX = "mailfinity:signup-resend:";

function storageKey(email: string): string {
  return KEY_PREFIX + email.trim().toLowerCase();
}

/** Whole seconds left before another resend is allowed (0 = allowed now). */
export function secondsUntilResend(lastSentAt: number | null, now: number): number {
  if (lastSentAt === null) return 0;
  const elapsed = Math.max(0, now - lastSentAt);
  return Math.max(0, Math.ceil((RESEND_COOLDOWN_MS - elapsed) / 1000));
}

export function readLastSentAt(storage: Storage | null, email: string): number | null {
  try {
    const value = Number(storage?.getItem(storageKey(email)));
    return Number.isFinite(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
}

export function recordSent(storage: Storage | null, email: string, at: number): void {
  try {
    storage?.setItem(storageKey(email), String(at));
  } catch {
    // Storage blocked (private mode): the cooldown just won't survive a reload.
  }
}
